/**
 * Debounce function to limit the rate at which a function can fire
 * @param {Function} func - The function to debounce
 * @param {number} wait - The number of milliseconds to delay
 * @param {boolean} immediate - Whether to call the function immediately on the first invocation
 * @returns {Function} The debounced function with a cancel() method
 */
const debounce = (func, wait, immediate = false) => {
    let timeout;

    function cancel() {
        if (timeout != null) {
            clearTimeout(timeout);
            timeout = null;
        }
    }

    function executedFunction(...args) {
        const later = () => {
            timeout = null;
            if (!immediate) func(...args);
        };

        const callNow = immediate && !timeout;

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) func(...args);
    }

    executedFunction.cancel = cancel;
    return executedFunction;
};

export default debounce;
